export const FEATURE_FLAGS = [
  'payments',
  'studentImages',
  'libraryImageRefresh',
  'videoSharing',
] as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[number];

export const VIDEO_FORMATS = ['16-9', '9-16', '1-1'] as const;
export type VideoFormat = (typeof VIDEO_FORMATS)[number];

export type AppConfig = {
  version: 1;
  tenant: {
    id: number;
    siteName: string;
    siteTitle: string;
  };
  features: Readonly<Record<FeatureFlag, boolean>> & {
    readonly videoFormats: readonly VideoFormat[];
  };
  branding: {
    logoUrl: string;
    faviconUrl: string;
    brandColor: string;
  };
  copy: {
    idLabel: string;
    idPlaceholder: string;
    loginInstruction: string;
    shareConsentText: string | null;
  };
  urls: {
    chatbotApiBase: string;
    releaseFormUrl: string | null;
  };
  analytics: {
    gaPropertyId: string | null;
  };
  upscaleComparison: {
    beforeUrl: string | null;
    afterUrl: string | null;
  };
};
